// eslint-disable-next-line import/no-cycle
import { getAuditDetail, getTemplateDetail, fetchAuditUser } from '@/api/approvalApi'

const TypeMapper = new Map([
  ['NONE', 1],
  ['AND', 2],
  ['OR', 3],
])
// 获取审批类型'NONE'-单人审批， 'AND'-会签 'OR'-或签
const getType = (actionType) => {
  return TypeMapper.get(actionType) || 4
}

const auditApproveState = {
  state: {
    auditDetail: {},
    accountList: [], // 审批人集合
    templateDetail: {}, // 配置模版
  },
  mutations: {
    SET_TEMPLATE_DETAIL: async (state, payload) => {
      state.templateDetail = payload
    },
    SET_AUDIT_DETAIL: async (state, payload) => {
      state.auditDetail = payload
    },
    SET_ACCOUNT_LIST: (state, payload) => {
      state.accountList = payload
    },

    ADD_NODE: (state, payload) => { // 新增审批人节点
      const { flowList } = state.auditDetail
      if (flowList && flowList.length > 0) {
        flowList.splice(payload.nodeIndex, 0, payload)
      } else {
        state.auditDetail.flowList = [payload]
      }
      flowList.forEach((item, index) => { item.nodeIndex = index; item.level = index + 1 })
    },
    EDIT_NODE: (state, payload) => { // 编辑审批人节点
      const { flowList } = state.auditDetail
      flowList.splice(payload.nodeIndex, 1, payload)
    },
    DELETE_NODE: (state, payload) => { // 删除审批人节点
      const { nodeIndex } = payload
      const { flowList } = state.auditDetail
      flowList.splice(nodeIndex, 1)
      flowList.forEach((item, index) => { item.nodeIndex = index; item.level = index + 1 })
    },
  },

  actions: {
    async getAuditDetail({ commit }, params) {
      const res = await getAuditDetail(params)
      try {
        const { data } = res
        if (!res || !data) {
          commit('SET_AUDIT_DETAIL', {})
          return
        }
        if (data.flowList && data.flowList.length > 0) {
          data.flowList.forEach((flow) => {
            flow.approverInfosList = flow.actionType ? flow.approverList.map((item) => item.adminUid) : flow.ccList.map((item) => item.adminUid)
            flow.nodeIndex = flow.level - 1
            flow.actionType = getType(flow.actionType)
          })
        } else {
          data.flowList = []
        }
        commit('SET_AUDIT_DETAIL', res.data)
      } catch (error) {
        console.log(error, '===>getAuditDetail')
      }
    },
    async getAccountListAction({ commit }, params) {
      const res = await fetchAuditUser(params)
      if (res && res.data) {
        commit('SET_ACCOUNT_LIST', res.data)
      }
    },
    async getTemplateDetail({ commit }, params) {
      const res = await getTemplateDetail(params)
      try {
        const { code, data } = res
        if (res && code === 1 && data && data.form) {
          const tempData = []
          const formData = JSON.parse(data.form)
          let currentForm = []
          formData && formData.forEach((item) => {
            // 遇到table
            if (item.children && item.children.length > 0) {
              // 遇到table 这个表单结束 新起一个表单
              if (currentForm.length > 0) {
                tempData.push({
                  type: 'form',
                  data: currentForm,
                })
                currentForm = []
              }

              // 新加一个只有当前项的表单当做表格的title
              tempData.push({
                type: 'form',
                data: [{ label: item.props.label }],
              })
              // 添加表格数据
              tempData.push({
                type: 'table',
                // eslint-disable-next-line no-shadow
                data: item.children.map((item) => ({ label: item.props.label })),
              })
              return
            }
            currentForm.push({ label: item.props.label })
          })
          // 最后结束是表单的情况
          currentForm.length > 0 && tempData.push({ type: 'form', data: currentForm })
          commit('SET_TEMPLATE_DETAIL', tempData)
        }
      } catch (error) {
        console.log(error, '===>getTemplateDetail')
      }
    },
  },
}
export default auditApproveState
